export default {

    SET_SELECT_DESIGNATED_MEMBER({commit},DesignatedMember){
        commit('SET_SELECT_DESIGNATED_MEMBER',DesignatedMember)
    },
    SET_RESULT({commit},result){
        commit('SET_RESULT',result)
    },
    SET_EDIT_DESIGNATED_MEMBER({commit},editDesignatedMember){
        commit('SET_EDIT_DESIGNATED_MEMBER',editDesignatedMember)
    },
}